const avatarHtml = (photo) => {
  const styles = 'display:block;'
  return photo ? `<img src="${photo}" alt="user photo" width="158" style="${styles}"/>` : ''
}

const setBlock = ({tag, styles}, text) => {
  return text ? `<${tag} style="${styles}">${text}</${tag}>` : ''
}

const setLink = (styles, href, text) => {
  return href ? ` <a href=${href} target="_blank" style="${styles}">${text}</a>` : ''
}

const setImg = (src, alt) => {
  const height = 30
  const styles = 'display:inline-block; vertical-align:middle;'
  return src ? ` <img alt="${alt || ''}" height="${height}" style="${styles}" src="${src}"/>` : ''
}

export {setBlock, setLink, setImg, avatarHtml}



// WEBPACK FOOTER //
// ./src/constants/signatureGmail/templatesType2.js